import axios from "axios"

export default {
  getAdAccountImages(adAccountId) {
    const url = `/fam/adaccounts/${adAccountId}/admedia/adimages`

    return axios.get(url).then(response => {
      return response.data
    })
  },
  uploadAdAccountImage(adAccountId, image) {
    let formData = new FormData()
    formData.append("image", image)

    const url = `/fam/adaccounts/${adAccountId}/admedia/adimages`

    return axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  },
}
